/**
 * Created by JasonChou on 17/6/23.
 */
import {createStore, applyMiddleware, compose,} from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducers';

export default function configureStore(initialState) {

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

    const enhancer = composeEnhancers(
        applyMiddleware(thunk),
    );
    const store = createStore(reducer, initialState, enhancer);
    return store;
}


// WEBPACK FOOTER //
// ./src/apps/portfolio/configureStore.js